import React from 'react';
import { useConfig } from '../../../../../store/reducers/config';
import ContinueSeries from '../../continue-series-section';
import { useGetMyListRow } from '../../../../../client/query/my-list';

interface IProps {
  title: string;
  href: string;
  index?: number;
}

const MyListRow: React.FC<IProps> = ({ title, href, index }) => {
  const { isLoggedIn } = useConfig();
  const { data, isError, isLoading, refetch } = useGetMyListRow();
  const shouldShowMyListRow = isLoggedIn && (isLoading || data);

  if (!isLoggedIn || !shouldShowMyListRow) return null;

  return (
    <ContinueSeries
      reload={refetch}
      myList={data}
      title={title}
      isError={isError}
      isLoading={isLoading}
      href={href}
      analytics={{
        engagementData: {
          rowNumber: index,
        },
      }}
    />
  );
};

export default MyListRow;
